class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if ((!this.contains(event.target) || event.target.classList.contains('modal-overlay')) && !event.target.parentElement.classList.contains('search-filters__list') && !event.target.closest('#product-disclaimer-modal')) this.close(false);
  }

  open(event) {
    //console.log('event din search modal', event)
    if (event.target.closest('.bottom-island__search-btn')) {
      this.detailsContainer.setAttribute('open', true);
    }
    else {
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      event.target.closest('details').setAttribute('open', true);

      //prevent header to hide when opening the search modal
      document.querySelector('sticky-header').preventHide = true;
    }

    // document.body.addEventListener('click', this.onBodyClickEvent);
    // Add event listener to elements with the class 'modal-overlay'
    this.querySelectorAll('.modal-overlay').forEach((overlay) => {
      overlay.addEventListener('click', this.close.bind(this));
    });
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.querySelector('header .header__box--right').classList.remove('search-modal--open');

    //allow header to hide after search bar is closed
    document.querySelector('sticky-header').preventHide = false;
  }
}

customElements.define('details-modal', DetailsModal);